import React from "react";

import CopyIconButton from "components/atoms/CopyIconButton";

import { TabProps } from "../../../../SourceModal.types";
import BaseOverview from "./BaseOverview";

const AdjustOverview: React.FC<TabProps> = ({ source, language }) => {
    const webhookUrl = source?.event_tracking_webhook_url;
    const callbackUrl = webhookUrl
        ? `${webhookUrl}?created_at={created_at}&event={event}&event_name={event_name}&label={label}&partner_parameters={partner_parameters}&partner={partner}&currency={currency}&revenue_float={revenue_float}&ip_address={ip_address}&user_agent={user_agent}&country={country}&city={city}&gps_adid={gps_adid}&idfa={idfa}&idfv={idfv}&tracker_token={tracker_token}&tracker_name={tracker_name}&app_name={app_name}&activity_kind={activity_kind}&gclid={gclid}&meta_install_referrer_is_click={meta_install_referrer_is_click}&environment={environment}&fbpid={fbpid}&fbclid={fbclid}&fb_install_referrer={fb_install_referrer}&meta_install_referrer={meta_install_referrer}&click_referer={click_referer}&referrer={referrer}&att_status={att_status}&network_name={network_name}&tracking_enabled={tracking_enabled}&adid={adid}&idfa_md5={idfa_md5}&gps_adid_md5={gps_adid_md5}&adjust_id={adid}`
        : null;

    if (!webhookUrl) {
        return <BaseOverview language={language} />;
    }

    return (
        <div>
            <div className="mb-3" style={{ fontSize: "14px" }}>
                <strong>This process is mandatory for the event flow.</strong>{" "}
                You can create a callback using this URL for each event.
            </div>
            <div className="mb-2" style={{ fontSize: "14px" }}>
                It is recommended to include it for '<b>install</b>' and '
                <b>purchase</b>' events. If you wish to send all your events,
                adding it as a Global trigger will suffice.
            </div>
            <div>
                <h3 className="mb-2 mt-3">
                    <strong>
                        ⚠ IMPORTANT! Classic Setup Server Callback URL:
                    </strong>
                </h3>
            </div>
            <div className="bearer-token-area">
                <div className="bearer-token-blockquote">
                    <span style={{ fontSize: "12px" }}>{callbackUrl}</span>
                    <CopyIconButton value={callbackUrl || ""} />
                </div>
            </div>
            <p className="mt-2" style={{ fontSize: "16px" }}>
                More Info:{" "}
                <a
                    style={{ fontWeight: "700" }}
                    href="https://help.adjust.com/en/article/server-callbacks"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    https://help.adjust.com/en/article/server-callbacks
                </a>
            </p>
        </div>
    );
};

export default AdjustOverview;
